import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { inventoryTableRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: inventoryTableRow[];
  loading?: boolean;
};

 const InventoryTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();



  const columns = useMemo(
    () => [
      {
        id: "preserved",
        label: t("INVENTORY.TABLE.PRESERVED"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "inSupply",
        label: t("INVENTORY.TABLE.IN_SUPPLY"),
        minWidth: 90,
        align: "right",
      },
      {
        id: "description",
        label: t("INVENTORY.TABLE.DESCRIPTION"),
        minWidth: 140,
        align: "right",
        format: (row: inventoryTableRow) => t(row.description)
      },
      {
        id: "materialNumber",
        label: t("INVENTORY.TABLE.MATERIAL_NUMBER"),
        minWidth: 160,
        align: "right",
      }
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default InventoryTable;
